<template>
  <div class="mx-auto">
    <form @submit.prevent="search()" class="col-lg-12">
      <div class="row justify-content-center ">
        <input required :placeholder="$t('search.single.placeholder')"
               class="my-1 form-control col-lg-5 col-md-5 col-sm-12" type="text"
               v-model="words">
        <select class="my-1 custom-select col-lg-2 col-md-2 col-sm-12" name="search-type" v-model="type" id="">

          <option :class="`archive-section-all`" v-t="`search.single.all`" value="all"></option>
          <option :class="`archive-section-category`" v-t="`search.single.category`" value="category"></option>
          <option :class="`archive-section-brand`" v-t="`search.single.brand`" value="brand"></option>
          <option :class="`archive-section-product`" v-t="`search.single.product`" value="product"></option>
          <option :class="`archive-section-content`" v-t="`search.single.content`" value="content"></option>
          <option :class="`archive-section-course`" v-t="`search.single.course`" value="course"></option>
        </select>
        <button type="submit" class="my-1 btn btn-primary col-lg-2 col-md-2 col-sm-12 mx-2 search-btn-wrapper"
                v-t="`search.single.button_text`"></button>
      </div>
    </form>
  </div>
</template>

<script>
import router from "@/router";
import {searchTypes} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Search'

export default {
  name: "SearchInput",
  data() {
    return {
      words: this.$route.params.words,
      type: this.$route.params.type,
      searchTypes
    }
  },
  methods: {
    search() {
      this.$store.dispatch('Search/search', {type: this.type, words: this.words})
      router.push({name: 'Search', params: {words: this.words, type: this.type}})
    }
  }
}
</script>

<style scoped>

.search-btn-wrapper {
  font-size: 1rem;
  text-align: center;
}

</style>